import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ProcessImplementationState } from "./model";

let state: ProcessImplementationState = {
  processImplementations: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ProcessImplementationState, RootStateType>;
